import React from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";

const TermsConditions = () => {
    return (
        <>
            <Header />
            <section className="terms-page">

                <div className="terms-container">

                    <div className="terms-hero">

                        <span>TERMS & CONDITIONS</span>

                        <h1>
                            Terms &
                            Conditions
                        </h1>

                        <p>
                            Please read these Terms and Conditions carefully
                            before using the services provided by AppVerseLabs.
                            By accessing our website or engaging our services,
                            you agree to comply with these terms.
                        </p>

                    </div>

                    <div className="terms-content">

                        <div className="terms-block">
                            <h2>Acceptance of Terms</h2>

                            <p>
                                By accessing or using our website and services,
                                you acknowledge that you have read, understood
                                and agreed to these Terms and Conditions.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Services</h2>

                            <p>
                                AppVerseLabs provides mobile application
                                development, web development, UI/UX design,
                                consulting and related technology services.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Project Engagement</h2>

                            <p>
                                Project scope, timelines, pricing and
                                deliverables will be defined separately
                                through proposals, contracts or agreements
                                between AppVerseLabs and the client.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Payments</h2>

                            <p>
                                Clients agree to make payments according to
                                agreed milestones and payment schedules.
                                Delayed payments may impact project timelines.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Intellectual Property</h2>

                            <p>
                                Upon full payment, ownership of the final
                                approved deliverables will transfer to the
                                client unless otherwise stated in writing.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Confidentiality</h2>

                            <p>
                                Both parties agree to maintain confidentiality
                                regarding sensitive business information,
                                project details and proprietary materials.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Limitation of Liability</h2>

                            <p>
                                AppVerseLabs shall not be liable for indirect,
                                incidental or consequential damages arising
                                from the use of our services or website.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Changes to Terms</h2>

                            <p>
                                We reserve the right to update or modify these
                                Terms and Conditions at any time without prior
                                notice. Continued use of our services implies
                                acceptance of revised terms.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Contact Information</h2>

                            <p>
                                If you have any questions regarding these Terms
                                and Conditions, please contact us at
                                hello@appverselabs.com.
                            </p>
                        </div>

                    </div>

                    <div className="terms-contact">

                        <h3>
                            Need Clarification?
                        </h3>

                        <p>
                            Contact our team for any questions regarding our
                            terms, services or project agreements.
                        </p>

                        <a href="mailto:hello@appverselabs.com">
                            hello@appverselabs.com
                        </a>

                    </div>

                </div>

                <style>{`

                .terms-page{
                    padding:140px 24px;
                    background:#fff;
                }

                .terms-container{
                    max-width:1440px;
                    margin:auto;
                }

                .terms-hero{
                    text-align:center;
                    margin-bottom:90px;
                }

                .terms-hero span{
                    display:inline-block;
                    padding:10px 20px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-size:12px;
                    font-weight:700;
                    letter-spacing:1.5px;
                    margin-bottom:25px;
                }

                .terms-hero h1{
                    font-size:clamp(52px,8vw,80px);
                    line-height:.95;
                    margin-bottom:25px;
                    color:#111;
text-align: center;
                    letter-spacing:-3px;
                    font-family:'Syne',sans-serif;
                }

                .terms-hero p{
                    max-width:760px;
                    margin:auto;
                    color:#666;
                    font-size:18px;
                    text-align: center;
                    line-height:1.9;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                .terms-content{
                    border-top:1px solid #eee;
                }

                .terms-block{
                    padding:38px 0;
                    border-bottom:1px solid #eee;
                }

                .terms-block h2{
                    font-size:32px;
                    margin-bottom:16px;
                    color:#111;
                    font-family:'Syne',sans-serif;
                    position:relative;
                    padding-left:20px;
                }

                .terms-block h2::before{
                    content:"";
                    position:absolute;
                    left:0;
                    top:7px;
                    width:5px;
                    height:32px;
                    border-radius:20px;
                    background:#E8212A;
                }

                .terms-block p{
                    color:#666;
                    font-size:16px;
                    line-height:1.9;
                    padding-left:20px;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                .terms-contact{
                    margin-top:70px;
                    padding:50px;
                    border-radius:30px;
                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );
                    color:#fff;
                    text-align:center;
                }

                .terms-contact h3{
                    font-size:40px;
                    margin-bottom:15px;
                    font-family:'Syne',sans-serif;
                        text-align: center;
                }

                .terms-contact p{
                    text-align: center;
                    max-width:600px;
                    margin:0 auto 20px;
                    line-height:1.8;
                }

                .terms-contact a{
                    color:#fff;
                    text-decoration:none;
                    font-size:20px;
                    font-weight:700;
                }

                @media(max-width:768px){

                    .terms-page{
                        padding:100px 18px;
                    }

                    .terms-block h2{
                        font-size:24px;
                    }

                    .terms-contact{
                        padding:35px 25px;
                    }

                    .terms-contact h3{
                        font-size:30px;
                    }

                }

            `}</style>

            </section>
            <Footer/>
        </>
    );
};

export default TermsConditions;